import { render, staticRenderFns } from "./TabStatistics.vue?vue&type=template&id=27559446&scoped=true&"
import script from "./TabStatistics.vue?vue&type=script&lang=js&"
export * from "./TabStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TabStatistics.vue?vue&type=style&index=0&id=27559446&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27559446",
  null
  
)

export default component.exports